import classname from 'classnames/bind';

import { MochiLottie } from '../../mochi-lib/mochi-lottie';
import styles from './index.module.scss';
import lottieJson from './loading_mochi.json';

const cx = classname.bind(styles);

const LoadingMochi = ({ show = false }) => {
  const loadingMochiClass = cx({
    'loading-mochi': true,
    show,
  });

  return (
    <div className={loadingMochiClass}>
      <MochiLottie
        style={{ width: 70, height: 70 }}
        animationData={lottieJson}
        loop
      />
    </div>
  );
};

export default LoadingMochi;
